export default __webpack_public_path__ + "static/media/Statistic_HE_2014-2015.5fe87dfb.pdf";